/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';
import RadioGroup from '../../../../../components/form/elements/radio-group';
import InputDate from '../../../../../components/form/elements/date';
import TextArea from '../../../../../components/form/elements/text-area';
import { useParams } from 'react-router-dom';
import { useService } from '../../../../../services/services';
import { useTranslation } from 'react-i18next';
import Decimal from '../../../../../components/form/elements/decimal';
import StatusEnum from '../enums/event-status';
import { FormComponent } from '../../../../../components/form';
import File from '../../../../../components/form/elements/file';
import Select from '../../../../../components/form/elements/select';
import asyncCategories from './async-categories';
import Classifier from '../../../../../enums/classifier';
import calendarImage from '../calendar.svg';
import Disabled from '../../../../../components/form/elements/disabled';
import Watch from '../../../../../components/form/elements/watch';

enum StatusPragnent {
  pregnant = '1',
  notPregnant = '0',
}

function useFormBody() {
  const { animalEventService, dealService } = useService();

  const { farmId } = useParams<{
    farmId: string;
  }>();

  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const body = useMemo<FormComponent[]>(
    () => [
      RadioGroup(
        'status',
        [
          {
            label: tp('events.grazing.planned'),
            value: String(StatusEnum.planned),
          },
          {
            label: tp('events.grazing.completed'),
            value: String(StatusEnum.completed),
          },
        ],
        null,
        true
      ),

      InputDate(
        'date',
        tp('events.date'),
        null,
        null,
        true,
        calendarImage,
        true,
        true
      ),

      Watch(
        RadioGroup(
          'status_pregnant',
          [
            {
              label: tp('events.pregnant'),
              value: String(StatusPragnent.pregnant),
            },
            {
              label: tp('events.not_pregnant'),
              value: String(StatusPragnent.notPregnant),
            },
          ],
          null,
          true
        ),
        ({ value, setValue }) => {
          if (value === StatusPragnent.notPregnant) {
            setValue('number_of_fetuses', '0');
          }
        }
      ),

      Select('investigation_method', {
        asyncOptions: asyncCategories({
          t,
          dealService,
          farmId,
          classifierKeys: [Classifier.INVESTIGATION_METHODS],
        }),
        label: tp('events.investigation_method'),
        column: true,
        clearable: false,
      }),

      (rest) => {
        return (
          <>
            <div>
              <NumberOfFetusesField tp={tp} {...rest} />
              <span className="inline-block mt-1 input_comment">
                {tp('events.number_of_fetuses_comment')}
              </span>
            </div>
          </>
        );
      },

      TextArea('notes', tp('events.notes'), undefined, false, undefined, true),

      File(
        'file',
        null,
        false,
        animalEventService,
        true,
        transKeyPrefix.concat('animals.')
      ),
    ],
    []
  );
  return body;
}

export default useFormBody;

const NumberOfFetusesField = ({ tp, ...rest }) => {
  const NumberOfFetuses = useMemo(
    () =>
      Disabled(
        Decimal(
          'number_of_fetuses',
          tp('events.number_of_fetuses'),
          null,
          false,
          false,
          true
        ),
        {
          watchOn: ['status_pregnant'],
          callback: (value) => {
            return value[0] === StatusPragnent.notPregnant;
          },
        }
      ),
    []
  );

  return <NumberOfFetuses {...rest} />;
};
